import React from 'react';
import {
  MessageOutlined, PictureOutlined, CodeOutlined, ContactsOutlined,
  EditOutlined, GlobalOutlined, SoundOutlined, VideoCameraOutlined,
  BgColorsOutlined, CustomerServiceOutlined, BookOutlined, RobotOutlined,
  SearchOutlined, TranslationOutlined, ExperimentOutlined, AppstoreOutlined,
} from '@ant-design/icons';

/**
 * 将后端存储的 icon 名称 (Lucide 风格) 映射为 Ant Design 图标组件
 */
const ICON_MAP: Record<string, React.ReactNode> = {
  'message-circle': <MessageOutlined />,
  'image':          <PictureOutlined />,
  'code':           <CodeOutlined />,
  'briefcase':      <ContactsOutlined />,
  'pencil':         <EditOutlined />,
  'globe':          <GlobalOutlined />,
  'megaphone':      <SoundOutlined />,
  'video':          <VideoCameraOutlined />,
  'palette':        <BgColorsOutlined />,
  'music':          <CustomerServiceOutlined />,
  'book':           <BookOutlined />,
  'bot':            <RobotOutlined />,
  'search':         <SearchOutlined />,
  'languages':      <TranslationOutlined />,
  'flask':          <ExperimentOutlined />,
};

interface CategoryIconProps {
  name?: string;
  style?: React.CSSProperties;
}

const CategoryIcon: React.FC<CategoryIconProps> = ({ name, style }) => {
  if (!name) return <AppstoreOutlined style={style} />;
  const icon = ICON_MAP[name.toLowerCase()];
  return <span style={style}>{icon || <AppstoreOutlined />}</span>;
};

export default CategoryIcon;
